import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Lottie from "react-lottie";
import loadingAnimation from "../../assets/Lotties/ZinancialLoader.json";

const tailwindCommonStyles = "h-fit font-medium rounded-[4px] cursor-pointer flex items-center justify-center";

const buttonStyle = {
  primary:
    "hover:bg-primary bg-primary-80 text-[#FFF] disabled:hover:bg-primary disabled:cursor-not-allowed disabled:opacity-[50%]",
  secondary:
    "bg-secondary hover:bg-[white] border-solid border-[#D2DAE1] hover:border-primary hover:text-primary text-[#666] disabled:hover:bg-secondary disabled:cursor-not-allowed disabled:opacity-[50%]",
  oldPrimary:
    "bg-[#123251] text-white hover:bg-[#092239]  disabled:hover:bg-[#5489ff] disabled:cursor-not-allowed disabled:opacity-[50%]",
  oldSecondary:
    "bg-[#F4F4F4]  text-[#666] hover:bg-[#ebf1f5]   disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:opacity-[50%]",
  delete:
    "bg-[#F84545] border-[#F16136] text-white hover:bg-[#D22F2F]  disabled:hover:bg-[#F84545] disabled:cursor-not-allowed disabled:opacity-[50%]",
  action:
    "bg-2999BC text-white font-poppins font-normal hover:bg-[#217A96]  disabled:hover:bg-[2999BC] disabled:cursor-not-allowed disabled:opacity-[50%]",
  discard:
    "bg-[#C8923B] text-white hover:bg-[#A67A2F]  disabled:hover:bg-[#C8923B] disabled:cursor-not-allowed disabled:opacity-[50%]",
  red: "bg-[#FF5E5E] text-white hover:bg-none disabled:hover:bg-[#FF5E5E] disabled:cursor-not-allowed disabled:opacity-[50%]",
};

const buttonSize = {
  small: "min-w-[30px] w-fit min-h-[20px] text-sm px-4 py-[4px]",
  medium: "min-h-[26px] text-base py-[4px] w-[90px]",
  large: "min-w-[50px] w-fit min-h-[20px] h-[36px] text-lg",
};

const Button = ({
  variant = "primary",
  isDisabled = false,
  style = {},
  children,
  onClick,
  type,
  className,
  size = "medium",
  isLoading,
  disableConditionForSave,
  ...rest
}) => {
  const parentRef = useRef(null);
  const [loaderWidth, setLoaderWidth] = useState("20px");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (parentRef.current) {
      const parentRect = parentRef?.current?.parentElement?.getBoundingClientRect();
      const parentWidth = parentRect.width;
      const parentHeight = parentRect.height;

      setLoaderWidth(`${parseInt(parentHeight * 0.8)}px`);
    }
  }, [isLoading]);

  return (
    <button
      className={`border relative ${buttonStyle[variant]} ${buttonSize[size]} ${tailwindCommonStyles} ${className}`}
      disabled={isDisabled}
      // style={{
      //   cursor: isDisabled ? "not-allowed" : "pointer",
      //   opacity: isDisabled ? 0.5 : 1,
      //   ...style,
      // }}
      onClick={onClick}
      type={type ? type : "button"}
      {...rest}
    >
      {isLoading && (
        <span
          ref={parentRef}
          className="absolute flex items-center justify-center w-full h-full bg-black rounded-[5px]"
        >
          <div style={{ width: loaderWidth, height: loaderWidth }}>
            <Lottie options={defaultOptions} isClickToPauseDisabled />
          </div>
        </span>
      )}
      {children}
    </button>
  );
};

export default Button;
